import React, { useState }  from 'react';
import PropTypes            from 'prop-types';
// import classNames       from 'classnames';

import Button               from '../../../components/Button';
import Icons                from '../../../../assets/svg/icons.js'

import styles               from '../AccountPage.styl';

function CongratulationsTab(props) {
    const {
        onChangeTab,
        onCreate,
        values
    } = props;

    const {
        name,
        firstName,
        lastName,
        email,
        phone,
        url
    } = values;

    const [ isLoading, setLoading ] = useState(false);
    const [ saveError, setSaveError ] = useState('');

    async function handleComplete() {
        setLoading(true);
        try {
            await onCreate();
        } catch(err) {
            setSaveError(err);
        } finally {
            setLoading(false);
        }
    }

    function handleClearError() {
        setSaveError('');
    }

    return  (
        <div
            className = {styles.CongratulationsTab}
        >
            <h2 className={styles.title}>
                {'Congratulations, you have successfully registered an account in the "Roimax" service.'}
            </h2>
            <div className={styles.wrapper}>
                <div className={styles.valueBlock}>
                    <div className={styles.valueLabel}>
                        Company name
                    </div>
                    <div className={styles.valueData}>
                        {name}
                    </div>
                </div>
                <div className={styles.valueBlock}>
                    <div className={styles.valueLabel}>
                        Organization URL
                    </div>
                    <div className={styles.valueData}>
                        {url}
                    </div>
                </div>
                <div className={styles.valueBlock}>
                    <div className={styles.valueLabel}>
                        First Name
                    </div>
                    <div className={styles.valueData}>
                        {firstName}
                    </div>
                </div>
                <div className={styles.valueBlock}>
                    <div className={styles.valueLabel}>
                        Last Name
                    </div>
                    <div className={styles.valueData}>
                        {lastName}
                    </div>
                </div>
                <div className={styles.valueBlock}>
                    <div className={styles.valueLabel}>
                        Email
                    </div>
                    <div className={styles.valueData}>
                        {email}
                    </div>
                </div>
                <div className={styles.valueBlock}>
                    <div className={styles.valueLabel}>
                        Phone number
                    </div>
                    <div className={styles.valueData}>
                        {phone}
                    </div>
                </div>
            </div>
            <div className={styles.info}>
                {'Please check the correctness of the entered data and confirm. Be careful to the email address that you specified, as a link to go to your "Roimax" service and a password to enter will be sent to this email.'}
            </div>
            <div className={styles.wrapper}>
                <Button
                    className = {styles.button}
                    color     = 'gradient'
                    onClick   = {handleComplete}
                    loading   = {isLoading}
                >
                    Complete registration
                </Button>
                <div
                    className = {styles.backLink}
                    onClick   = {onChangeTab('account')}
                >
                    Back to creating account for editing
                </div>
            </div>
            {saveError
                ? <div className={styles.modalWrapper}>
                    <div className={styles.errorModal}>
                        <span
                            className = {styles.closeModal}
                            onClick   = {handleClearError}
                        >
                            <Icons.Cancel />
                        </span>
                        <div className={styles.modalTitle}>
                            {'Something Went Wrong'}
                        </div>
                        <div className={styles.modalContent}>
                            {saveError}
                        </div>
                        <div
                            className = {styles.backLink}
                            onClick   = {onChangeTab('account')}
                        >
                            {'Back to creating account for editing'}
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    );
}

CongratulationsTab.propTypes = {
    onChangeTab : PropTypes.func.isRequired,
    values      : PropTypes.object.isRequired,
    onCreate    : PropTypes.func.isRequired
};

// CongratulationsTab.defaultProps = {
//     onChangeTab : ''
// };

export default CongratulationsTab;
